<template>
  <div class="content">
    <ContentIntroSection/>
    <ContentOurBrandsSection/>
    <ContentForeignismSection/>
    <ContentInclusiveSection/> 
    <ContentExpressionsSection/>     
  </div>
</template>

<script lang="ts">
import ContentIntroSection from '@/components/VerbalIdentityPage/sections/content/ContentIntroSection.vue'
import ContentOurBrandsSection from '@/components/VerbalIdentityPage/sections/content/ContentOurBrandsSection.vue'
import ContentForeignismSection from '@/components/VerbalIdentityPage/sections/content/ContentForeignismSection.vue'
import ContentInclusiveSection from '@/components/VerbalIdentityPage/sections/content/ContentInclusiveSection.vue'
import ContentExpressionsSection from '@/components/VerbalIdentityPage/sections/content/ContentExpressionsSection.vue'
import { Component, Vue } from 'vue-property-decorator'


@Component({
  components: {
    ContentIntroSection,
    ContentOurBrandsSection,
    ContentForeignismSection,
    ContentInclusiveSection,
    ContentExpressionsSection
  }
})
export default class ContentView extends Vue {}
</script>

<style lang="scss"></style>
